








































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { PatientModel } from "@/models/patient";
import { inject } from 'inversify-props';
import { IUserService, UserType } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

type RegisterResult = {
  model: PatientModel;
  err?: Error;
};

@Component({})
export class PatientRegisterModal extends Vue {
  @inject(DependencyIdentifiers.UserService)
  private userService!: IUserService;

  @Prop({ required: true })
  patients!: PatientModel[];

  private componentKey = 0;
  private current: RegisterResult | null = null;
  private results: RegisterResult[] = [];

  private get progress() {
    if (this.patients.length === 0) {
      return 100;
    }
    return (this.results.length / this.patients.length) * 100;
  }

  private get remaining() {
    return this.patients.length - this.results.length;
  }

  async mounted() {
    const patients = [...this.patients];
    for (let i = 0; i < patients.length; i++) {
      const result: RegisterResult = { model: { ...patients[i] } };
      this.current = result;
      this.componentKey++;
      await new Promise(resolve => setTimeout(resolve, 1500));
      try {
        await this.userService.create(UserType.Patients, result.model.$id as string);
        this.onRegisterSuccess(result);
      } catch (err) {
        result.err = err;
        this.onRegisterFailure(result);
      } finally {
        this.current = null;
      }
      this.results = [result, ...this.results];
    }
    this.onComplete(this.results);
  }

  @Emit("complete")
  onComplete(result: RegisterResult[]) {
    return result;
  }

  @Emit("register:success")
  onRegisterSuccess(result: RegisterResult) {
    this.onRegister(result);
    return result;
  }

  @Emit("register:failure")
  onRegisterFailure(result: RegisterResult) {
    this.onRegister(result);
    return result;
  }

  @Emit("register")
  onRegister(result: RegisterResult) {
    this.componentKey++;
    return result;
  }
}

export default PatientRegisterModal;
